module.exports = require("./sq-XK.d.ts");